module.exports = __webpack_public_path__ + "img/logo_sim.9a0a0bb7.jpg";